import type { IconData } from '@stacksjs/iconify-core'

export const sr4x3: IconData = {
  "body": "<path fill=\"#377e3f\" d=\"M.1 0h640v480H.1z\"/><path fill=\"#fff\" d=\"M.1 96h640v288H.1z\"/><path fill=\"#b40a2d\" d=\"M.1 144h640v192H.1z\"/><path fill=\"#ecc81d\" d=\"m320 153.2l56.4 173.6l-147.7-107.3h182.6L263.6 326.8z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default sr4x3
